import { useEffect, useState } from 'react';
import { useDetailContext } from '../DetailContext';
import { ActionName, EventCallbackParamsType } from '../MockupEditor';
import CustomImage from "components/common/CustomImage";
import Slider from 'components/common/Slider';
import Stats from 'libs/utils/stats';


/**
 * 智能选区
 * @param props 属性
 * @param callback 修改属性后的回调
 * @returns 
 */
export default function AreaSelect(){
    const detailContext = useDetailContext();

    //  属性面板是否可用
    const [ isPanelEnable, setIsPanelEnable ]= useState<boolean>(false);
    
    const [ penSize, setPenSize ]= useState<number>(5);
    const [ type, setType ]= useState<number>(-1);

    // click时会触发分割服务，是否正在加载
    const [ isLoadingClick, setIsLoadingClick ] = useState<boolean>(true);

    const [ isSaving, setIsSaving ]= useState<boolean>(false);

    useEffect(() => {
        detailContext?.triggerEditorAction({
            name : ActionName.MOCKUP_AI_AREA_START,
        })
    },[])

    useEffect(() => {
        if(type > -1){
            if(type === 0){
                Stats.google('Area sel Smart click')
            }else {
                Stats.google('Area sel Daub')
            }
            return detailContext?.triggerEditorAction({
                name : ActionName.MOCKUP_AI_AREA_SEITCH_EDIT_TYPE,
                params: `${type}`
            })
        }
    },[ type ])

    // 处理编辑器相关的回调
    useEffect(() => {  
        const type = detailContext?.editorCallbackData?.type ;
        const data = detailContext?.editorCallbackData?.data ;
        switch(type){
            case EventCallbackParamsType.MOCKUP_AI_AREA_READY: // click调用分割服务已完成，就绪
                setIsPanelEnable(true);
                setIsLoadingClick(false);
                break;
            case EventCallbackParamsType.GET_PEN_SIZE_CALLBACK: // 画笔大小
                setPenSize(+detailContext?.editorCallbackData?.data);
                break;
            case EventCallbackParamsType.MOCKUP_AI_AREA_PROCESS_CALLBACK: // 智能选区生效后的回调
                // 关闭画笔
                detailContext?.triggerEditorAction({
                    name: ActionName.VECTOR_AI_ERASE_CLOSE,
                })
                setIsSaving(false);
                detailContext?.setModelEditType(0);
                break;
            // case EventCallbackParamsType.ERASE_DRAW_EXIT_CALLBACK: // 画笔退出后的回调
                // setIsColorExpand(false);
                // setIsFineTuningExpand(false);
                break;
        }
    },[detailContext?.editorCallbackData])
    
    useEffect(() => {  
        const type = detailContext?.editorAction?.name;
        switch(type){
            case ActionName.LOADING_IMAGE:
                cancel();
                break;
        }
    },[detailContext?.editorAction])

    // 保存
    const save = async () => {
        if(isLoadingClick) return ;
        setIsSaving(true);
        detailContext?.triggerEditorAction({
            name : ActionName.MOCKUP_AI_AREA_PROCESS,
        })
    }

    // 退出
    const cancel = () => {
        if(isLoadingClick) return ;
        detailContext?.setModelEditType(0);
        detailContext?.triggerEditorAction({
            name : ActionName.VECTOR_AI_ERASE_CLOSE,
        })
    }

    const reset = () => {
        detailContext?.triggerEditorAction({
            name : ActionName.MOCKUP_AI_AREA_RESET,
        })
    }
    
    // 设置画笔大小
    const penChangeHandler = (size: number) => {
        detailContext?.triggerEditorAction({
            name: ActionName.SETTING_PEN_SIZE,
            params: `${size}`
        })
    }

    return (
        <>
        {
            <>
                <div className="absolute z-[1201] right-0 top-0 bg-[#FFFFFF]  xl:w-[260px] w-[210px] h-full p-[10px] xl:p-[20px]">
                    <p className="medium-txt font-bold">Select the design pattern display area</p>
                    <div className="relative flex flex-col mt-[10px] xl:mt-[20px] gap-[10px]"
                        style={{
                            color: isPanelEnable ? '#000000' : '#BFBFBF'
                        }}>
                            {
                                !isPanelEnable &&
                                <div className='absolute z-[10] left-0 top-0 w-full h-full cursor-not-allowed'></div>
                            }
                        <div className="flex gap-[25px]">
                            <div className="flex flex-col gap-[5px] items-center justify-center cursor-pointer" 
                                onClick={() => setType(2)}>
                                <p className={`p-[10px] rounded-[10px] ${type == 2 || type == -1 ? 'border border-[#14A5FA]': ''}`}><CustomImage src={`/icon/icon-editor-area-click.png`} className="w-[30px] h-[30px]"/></p>
                                <span className={`small-txt font-[500] ${!isPanelEnable && 'text-[#000000]'}`}>Click</span>
                            </div>
                            <div className="flex flex-col gap-[5px] items-center justify-center cursor-pointer"
                                onClick={() => setType(1)}>
                                <p className={`p-[10px] rounded-[10px] ${type == 1 ? 'border border-[#14A5FA]': ''}`}><CustomImage src={`/icon/icon-editor-area-pen${isPanelEnable ? '' : '-disabled'}.png`} className="w-[30px] h-[30px]"/></p>
                                <span className="small-txt font-[500]">Daub</span>
                            </div>
                            <div className="flex flex-col gap-[5px] items-center justify-center cursor-pointer"
                                onClick={() => setType(0)}>
                                <p className={`p-[10px] rounded-[10px] ${type == 0 ? 'border border-[#14A5FA]': ''}`}><CustomImage src={`/icon/icon-editor-area-eraser${isPanelEnable ? '' : '-disabled'}.png`} className="w-[30px] h-[30px]"/></p>
                                <span className="small-txt font-[500]">Eraser</span>
                            </div>
                        </div>
                        {
                            (type == 1 || type == 0) && 
                            <div>
                                <span className="small-txt font-[500]">Brush size</span>
                                <div>
                                    <Slider init={penSize} changeHandler={penChangeHandler} />
                                </div>
                            </div>
                        }
                        
                        <div>
                            <p className="flex gap-[5px] py-[10px] w-full border border-[#D9D9D9] items-center justify-center rounded-[5px] cursor-pointer"
                                onClick={reset}>
                                <CustomImage src={`/icon/icon-editor-area-reset${isPanelEnable ? '' : '-disabled'}.png`} className="w-[20px] h-[20px]"/>
                                <span className="small-txt font-[500]">Reset Constituency</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div className="absolute bottom-[10px] xl:bottom-[20px] left-[50%] translate-x-[-50%] flex items-center gap-[10px] z-[1202]">
                    <div className="bg-[#D9D9D9] p-[8px] rounded-[10px] cursor-pointer"
                        onClick={cancel}><CustomImage src="/icon/icon-cancel.png" className="w-[26px] h-[26px] xl:w-[34px] xl:h-[34px] "/></div>
                    <div className="bg-[#14A5FA] p-[8px] rounded-[10px] cursor-pointer "
                        onClick={save}>
                        {
                            isSaving ?
                            <p className="animate-spin">
                                <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4287" className="w-[26px] h-[26px] xl:w-[34px] xl:h-[34px]" ><path d="M96 512c0-19.33 15.67-35 35-35s35 15.67 35 35c0 191.09 154.91 346 346 346s346-154.91 346-346-154.91-346-346-346c-19.33 0-35-15.67-35-35s15.67-35 35-35c229.75 0 416 186.25 416 416S741.75 928 512 928 96 741.75 96 512z" fill="#10F28D" p-id="4288"></path></svg>
                            </p>
                            :
                            <CustomImage src="/icon/icon-confirm.png" className="w-[26px] h-[26px] xl:w-[34px] xl:h-[34px]"/>
                        }
                    </div>
                </div>
            </>
        }

            {/* <ElementTips /> */}
        </>
    )
}